/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { LegacyCurrentActiveChartProfileViewModel } from './LegacyCurrentActiveChartProfileViewModel'; 

export function getLegacyCurrentActiveChartProfileOptions(patientCode: string, onSuccess?: (result: LegacyCurrentActiveChartProfileViewModel) => void) {
	return queryOptions({
		queryKey: ['legacy-current-active-chart-profile', patientCode],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/patients/getlegacycurrentactivechartprofile/' + patientCode;
			const resp = await axios.get<LegacyCurrentActiveChartProfileViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(patientCode)
	});
}